<template>
  <input type="text" :class="{error:op[prop].error}" @focus="focus" @blur="refresh"
	 v-model="field" @keyup="keyUp"/>
</template>

<script>
import { Operation } from '@/lib/base.js';

export default {
  name: 'InputCoeff',
  props: {
    op: Operation,
    prop: String,
  },
  data: function(){
    return {
      field: this.op[this.prop].input
    }
  },
  methods: {
    focus(){
      this.op.type = this.action;
    },
    refresh(){
      this.field = this.op[this.prop].input;
    },
    keyUp(event){
      if(! '-/().0123456789'.includes(event.key)){
	this.$parent.keyUp(event);
      }
    }
  },
  computed: {
    action(){
      return this.prop.split('_')[1];
    }
  },
  watch: {
    field: function(to,from){
      if(to.match(/^[0-9/\-().]*$/)){
  	this.op[this.prop].input = to;
      }else{
  	this.field = from;
      }
    },
    op: function(){
      this.refresh();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
